import { CyclesInterface } from 'types/user';

type AppreciationPeriod = Pick<CyclesInterface, 'date_evaluation_step2_start' | 'date_evaluation_step5_finish'>;

/**
 * Período de apreciação da fase: do início da validação ao fim do Nível 3.
 *
 * Na edição pelo gestor, a inclusão de participantes vale para o período inteiro, e não só para as
 * janelas de validação, Nível 2 e Nível 3: as regras da apreciação também liberam a edição nos
 * intervalos entre elas (lateralidade de realização expirada, gestor original de Nível 2 ou 3, Pit
 * Stop). Quem pode editar em cada momento continua decidido por essas regras.
 */
export function isWithinAppreciationPeriod(stage: AppreciationPeriod, timestamp: number): boolean {
  return timestamp >= stage.date_evaluation_step2_start && timestamp <= stage.date_evaluation_step5_finish;
}
